import { render, staticRenderFns } from "./BuyNum.vue?vue&type=template&id=67785b23&scoped=true&"
import script from "./BuyNum.vue?vue&type=script&lang=js&"
export * from "./BuyNum.vue?vue&type=script&lang=js&"
import style0 from "./BuyNum.vue?vue&type=style&index=0&id=67785b23&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67785b23",
  null
  
)

export default component.exports